import { useLoading } from "@sg-core/index";
import { makeSuccess, TResult, makeFailure } from "@sg-core//index";
import { useHprService } from '../../context/HprServiceContext';
import { IPerson } from '../../models/IPerson';
import { usePersonCache } from './usePersonCache';
import { useMemo } from 'react';
import { useHprSettings } from '../hprSettings/useHprSettings';

interface IUseSearchPersonData {
    search: (text: string, requiredCerts?: Array<string>) => Promise<TResult<IPerson[]>>;
    searching: boolean;
    searchError?: string;
};

export type IUseSearchPersonHook = () => IUseSearchPersonData;

export const useSearchPerson: IUseSearchPersonHook = () => {

    const {
        loading: searching,
        loadError: searchError,
        startLoading,
        loadSuccess,
        loadErrored,
    } = useLoading();

    const { data: settings } = useHprSettings();
    const certList = settings?.certs ? Object.keys(settings?.certs) : [];


    const service = useHprService();
    const { appendPersons } = usePersonCache();

    const search = async (text: string, requiredCerts?: Array<string>): Promise<TResult<IPerson[]>> => {
        try {

            startLoading();
            const result = await service.searchPersonByText(text, certList, requiredCerts);

            if (result.isSuccess) {
                loadSuccess();
                await appendPersons(result.value);
                return makeSuccess(result.value);
            };
            throw result.error;
        } catch (error) {
            //  console.info(error);
            loadErrored((error as Error).message);
            return makeFailure(error as Error)
        };
    };

    return useMemo(() => ({
        search,
        searching,
        searchError,
    }), [searching, searchError]); // eslint-disable-line
};
